import { render } from "./FilterBlock.vue?vue&type=template&id=b5a3e354"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/derolfgroep-ict/derolfgroep-ict/web/app/themes/rolfhardware/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__